import { initializeApp } from "firebase/app";
import { getAuth, RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth"; // ✅ MISSING IMPORTS ADDED

const firebaseConfig = {
  apiKey: "AIzaSyDZgqBp63YG4xfPqF-ybNadcuBSbMr1OGg",
  authDomain: "otpverify-b111e.firebaseapp.com",
  databaseURL: "https://otpverify-b111e.firebaseio.com",
  projectId: "otpverify-b111e",
  storageBucket: "otpverify-b111e.firebasestorage.app",
  messagingSenderId: "876556500941",
  appId: "1:876556500941:web:b09de6def8067685944e84",
  measurementId: "G-GWZCFVTKP8"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app); // ✅ auth was never initialized

// 🔐 Setup Recaptcha — reset if already exists
export const setupRecaptcha = () => {
  if (window.recaptchaVerifier) {
    try { window.recaptchaVerifier.clear(); } catch (e) {}
    window.recaptchaVerifier = null;
  }

  window.recaptchaVerifier = new RecaptchaVerifier(
    auth,
    "recaptcha-container",
    { size: "invisible" }
  );
};

// 📲 Send OTP
export const sendOTP = async (phoneNumber) => {
  try {
    setupRecaptcha();
    const appVerifier = window.recaptchaVerifier;
    const result = await signInWithPhoneNumber(auth, phoneNumber, appVerifier);
    return result;
  } catch (error) {
    console.error("Firebase OTP error:", error.code, error.message);
    if (window.recaptchaVerifier) {
      try { window.recaptchaVerifier.clear(); } catch (e) {}
      window.recaptchaVerifier = null;
    }
    throw error;
  }
};